import { Box } from "@mui/material";

const FormHeaderBar = () => {
  // does not display on mobile
  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        pr: 4,
        borderRadius: 0,
        backgroundColor: "secondary.main",
        borderBottom: "2px solid",
        borderBottomColor: "primary.main",
        height: 70,
        flexShrink: 0,
        display: { xs: "none", md: "block" },
      }}
    />
  );
};

export default FormHeaderBar;
